export function getHtml() {
  return `
  <div style="width: 384px;height: 500px; border: 1px solid #666">
    <style>
      @import url('https://fonts.googleapis.com/css2?family=Roboto+Condensed:ital,wght@0,300;0,400;1,700&display=swap');

      p {
        font-family: 'Roboto Condensed', sans-serif;
        letter-spacing: -1px;
      }

      .bold {
        font-weight: 500;
      }

      .grey {
        color: #828282;
      }

      .blue {
        color: #0d68b7;
      }

    </style>

    <p>CNPJ: 32.579.520/0001-97</p>
    <p>CNPJ: 32.579.520/0001-97</p>
  </div>
  `;
}
